import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import AddVehicle from "./AddVehicle";
import { forwardRef, useEffect, useRef, useState } from "react";
import axios from "axios";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import Select from "react-select";
import OtpInput from "react-otp-input";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import GooglePlacesAutocomplete, { geocodeByPlaceId } from 'react-google-places-autocomplete';

const MySwal = withReactContent(Swal)

const Profile = () => {
  const [stages, setStages] = useState([]);
  const [address, setAddress] = useState({});
  const [vehicleData, setVehicleData] = useState({
    vehicle_image: null,
    vehicle_type: "boda",
    vehicle_sub_type: '',
    vehicle_brand: '',
    vehicle_model: '',
    vehicle_color: '',
    district: '',
    stage: '',
    number_plate: null,
    vehicle_number_plate: '',
    insurance: null,
    insurance_expiry: '',
    insurance_number: ''

  });
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    profile_photo: "", // file
    phone_code: "256",
    phone_number: "",
    gender: "",
    dob: "",
    national_id: null, // file
    national_id_number: "",
    national_id_expiry: "",
    driving_permit: null, // file
    driving_permit_number: "",
    driving_permit_expiry: ""
  });
  const [districts, setDistricts] = useState([]);
  const [errors, setErrors] = useState({});
  const [previews, setPreviews] = useState({
    profile_photo: null,
    number_plate: null,
    insurance: null
  });
  const drivingPermitRef = useRef();
  const nationalIDRef = useRef();
  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Other", value: "other" },
  ]
  const [otp, setOtp] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getDistricts();
  }, [])

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const firstError = Object.keys(errors)[0];
      if (firstError) {
        const errorElement = document.querySelector(`.invalid-feedback`);
        if (errorElement) {
          const formGroup = errorElement.closest('.form-group');
          if (formGroup) {
            formGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }
    }
  }, [errors]);

  function getDistricts() {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/accounts/district-list/`)
      .then((response) => {
        setDistricts(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleImageClick = (ref) => {
    if (ref.current) {
      ref.current.click();
    }
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) { // 10MB limit
        setErrors({
          ...errors,
          [field]: "File size should not exceed 10MB"
        });
        return;
      }
      const previewUrl = URL.createObjectURL(file);
      setPreviews({
        ...previews,
        [field]: previewUrl
      });
      if (e.target.dataset.tab) {
        setVehicleData({
          ...vehicleData,
          [field]: file
        });
      } else {
        setUserData({
          ...userData,
          [field]: file
        });
      }
      setErrors({
        ...errors,
        [field]: ""
      });
    }
  };

  const getMinimumDate = () => {
    const today = new Date();
    const eighteenYearsAgo = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate()
    );
    return eighteenYearsAgo.toISOString().split('T')[0];
  };

  const handleUserInput = (field, value) => {
    if (field === 'dob') {
      const selectedDate = new Date(value);
      const minDate = new Date(getMinimumDate());

      if (selectedDate > minDate) {
        setErrors({ ...errors, dob: "You must be at least 18 years old" });
        return;
      }
    }

    setUserData({
      ...userData,
      [field]: value
    });
    setErrors({ ...errors, [field]: "" });
  };

  const handlePhoneChange = (value, data) => {
    setUserData({
      ...userData,
      phone_number: value.slice(data.dialCode.length)
    });
    setErrors({ ...errors, phone_number: "" });
  };

  const InputFileFieldRender = forwardRef((props, ref) => {
    return (
      <div className="document-inner" onClick={() => handleImageClick(ref)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
        >
          <g clipPath="url(#clip0_1660_8872)">
            <path
              d="M14.5033 16.0293H10.6879V12.174H11.9488C12.2686 12.174 12.4575 11.8106 12.2686 11.549L9.81585 8.15517C9.6596 7.93715 9.3362 7.93715 9.17996 8.15517L6.72724 11.549C6.53829 11.8106 6.7236 12.174 7.047 12.174H8.30788V16.0293H4.0347C2.12702 15.9239 0.608154 14.1398 0.608154 12.2067C0.608154 10.8731 1.33125 9.71037 2.40318 9.08175C2.30507 8.81649 2.2542 8.53307 2.2542 8.23511C2.2542 6.87248 3.3552 5.77148 4.71782 5.77148C5.01215 5.77148 5.29558 5.82236 5.56083 5.92046C6.34934 4.24898 8.04989 3.08984 10.0266 3.08984C12.5847 3.09348 14.6922 5.05202 14.932 7.54834C16.8979 7.88627 18.3913 9.70674 18.3913 11.767C18.3913 13.969 16.6762 15.8767 14.5033 16.0293Z"
              fill="#67698E"
            />
          </g>
          <defs>
            <clipPath id="clip0_1660_8872">
              <rect
                width="17.7831"
                height="17.7831"
                fill="white"
                transform="translate(0.608154 0.668152)"
              />
            </clipPath>
          </defs>
        </svg>
        <div className="browse-btn">
          <Button type="button" variant="unset">
            Browse Computer
          </Button>
        </div>
        <span>Maximum file size is 10MB.</span>
      </div>
    );
  });

  const validateUserData = () => {
    const newErrors = {};
    if (!userData.profile_photo) {
      newErrors.profile_photo = "Profile photo is required";
    }
    if (!userData.name.trim()) {
      newErrors.name = "Full Name is required";
    }
    // if (!userData.email) {
    //   newErrors.email = "E-mail is required";
    // }

    if (!userData.phone_number.trim()) {
      newErrors.phone_number = "Phone Number is required";
    }

    if (!address?.label) {
      newErrors.address = "Address is required";
    }

    if (!userData.national_id) {
      newErrors.national_id = "National ID image is required";
    }

    if (!userData.national_id_number.trim()) {
      newErrors.national_id_number = "National ID Number is required";
    }

    // if (!userData.national_id_expiry) {
    //   newErrors.national_id_expiry = "National ID Expiry Date is required";
    // }

    // if (!userData.driving_permit) {
    //   newErrors.driving_permit = "Driving License image is required";
    // }

    // if (!userData.driving_permit_number.trim()) {
    //   newErrors.driving_permit_number = "License Number is required";
    // }

    // if (!userData.driving_permit_expiry) {
    //   newErrors.driving_permit_expiry = "License Expiry Date is required";
    // }

    if (userData.email && !/\S+@\S+\.\S+/.test(userData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!vehicleData.vehicle_image) newErrors.vehicle_image = "Vehicle image is required";
    if (!vehicleData.vehicle_sub_type) newErrors.vehicle_sub_type = "Vehicle subtype is required";
    if (!vehicleData.vehicle_brand) newErrors.vehicle_brand = "Brand is required";
    if (!vehicleData.vehicle_model) newErrors.vehicle_model = "Model is required";
    if (!vehicleData.vehicle_color) newErrors.vehicle_color = "Color is required";
    if (!vehicleData.district) newErrors.district = "District is required";
    // if (!vehicleData.stage) newErrors.stage = "Stage is required";
    if(!vehicleData.stage_name && vehicleData.stage === "other") {
      newErrors.stage_name = 'Stage name is required';
  }
    if (!vehicleData.vehicle_number_plate) newErrors.vehicle_number_plate = "Number plate is required";
    if (!vehicleData.number_plate) newErrors.number_plate = "Number plate image is required";
    // if (!vehicleData.insurance) newErrors.insurance = "Insurance document is required";
    // if (!vehicleData.insurance_expiry) newErrors.insurance_expiry = "Insurance number is required";
    // if (!vehicleData.insurance_number) newErrors.insurance_number = "Insurance expiry date is required";

    if (userData.dob) {
      const selectedDate = new Date(userData.dob);
      const minDate = new Date(getMinimumDate());
      if (selectedDate > minDate) {
        newErrors.dob = "You must be at least 18 years old";
      }
    }

    setErrors(prev => ({ ...prev, ...newErrors }));
    return Object.keys(newErrors).length === 0;
  }

  const addVehicleProps = {
    validateUserData: validateUserData,
    InputFileFieldRender: InputFileFieldRender,
    handleImageClick: handleImageClick,
    handleFileChange: handleFileChange,
    submitData: submitData,
    errors: errors,
    setErrors: setErrors,
    previews: previews,
    vehicleData: vehicleData,
    setVehicleData: setVehicleData,
    districts: districts,
    stages: stages,
    getStages: getStages
  }

  function submitData() {
    let userFormData = new FormData();
    for (const key in userData) {
      if(userData[key] && key !== 'phone_code') {
        userFormData.append(key, userData[key]);
      }
    }
    userFormData.append('phone_code', '+'+userData.phone_code);
    for (const key in vehicleData) {
      if (key === 'district') {
        userFormData.append(key, vehicleData[key].value);
      } else if(key === 'stage'){
        userFormData.append('stage', vehicleData.stage !== 'other' ? vehicleData.stage : '');
        if(vehicleData.stage_name){
          userFormData.append('stage_name', vehicleData.stage_name);
        }
      } else if(vehicleData[key]) {
        userFormData.append(key, vehicleData[key]);
      }
    }
    userFormData.append('address', address.label);
    MySwal.fire({
      title: "Submitting the form...",
      allowEscapeKey: false,
      allowOutsideClick: false,
    })
    MySwal.showLoading();
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/admin/add-driver/`, userFormData)
      .then((response) => {
        MySwal.close();
        MySwal.fire({
          icon: 'success',
          title: 'Profile Created Successfully. Please wait for profile approval.',
          showCancelButton: false,
        });
        setUserData({
          name: "",
          email: "",
          profile_photo: "", // file
          phone_code: "256",
          phone_number: "",
          gender: "",
          dob: "",
          national_id: null, // file
          national_id_number: "",
          national_id_expiry: "",
          driving_permit: null, // file
          driving_permit_number: "",
          driving_permit_expiry: ""
        });
        setVehicleData({
          vehicle_image: null,
          vehicle_type: "boda",
          vehicle_sub_type: '',
          vehicle_brand: '',
          vehicle_model: '',
          vehicle_color: '',
          district: '',
          stage: '',
          number_plate: null,
          vehicle_number_plate: '',
          insurance: null,
          insurance_expiry: '',
          insurance_number: ''
      
        });
      })
      .catch((error) => {
        MySwal.close();
        MySwal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.detail ? error.response?.data?.detail : 'Something went wrong!',
        });
        console.log(error);
      });
  }

  function getStages(district = vehicleData.district) {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/accounts/stage-list/?district=${district}`)
      .then((response) => {
        setStages(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const getDistrictName = (places) =>
    places?.flatMap(p => p.address_components || [])
      .find(c => c.types.includes("administrative_area_level_2") || c.types.includes("administrative_area_level_3"))
      ?.long_name || null;

  async function handleAddressChange(value) {
    setAddress(value);
    setErrors(prev => ({ ...prev, address:"", district:"" }));
    let placeResponse = await geocodeByPlaceId(value.value.place_id)
    let districtName = getDistrictName(placeResponse)
    if (districtName) {
      const matchingDistrict = districts.find(d =>
        d.name.toLowerCase() === districtName.toLowerCase()
      );
      if (matchingDistrict) {
        setVehicleData(prev => ({
          ...prev,
          district: { label: matchingDistrict.name, value: matchingDistrict.id }
        }));
        getStages(matchingDistrict.id)
      }
    }
  }

  return (
    <>
      <section className="common-area">
        <Container>
          <div className="profile-inner">
            <h2>Fill Your Details</h2>
          </div>
          <div className="personal-details">
            <h6>Personal Details</h6>
            <div className="profile-detail">
              <img src={previews.profile_photo ? previews.profile_photo : require("../assets/images/profile.png")} />
              <div className="camera-icon-outer">
                <div className="camera-icon">
                  <img src={require("../assets/images/camera.svg").default} />
                  <Form.Control type="file" name="profile_photo" onChange={(e) => handleFileChange(e, "profile_photo")} accept="image/*" />
                </div>
              </div>
            </div>
            {errors.profile_photo && <Form.Control.Feedback className="d-block" type="invalid">{errors.profile_photo}</Form.Control.Feedback>}
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your Full Name"
                    value={userData.name}
                    name="name"
                    maxLength={60}
                    onChange={(e) => handleUserInput('name', e.target.value)}
                    isInvalid={!!errors.name}
                  />
                  {errors.name && <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>}
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Email (Optional)</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter your Email"
                    value={userData.email}
                    maxLength={80}
                    onChange={(e) => handleUserInput('email', e.target.value)}
                    isInvalid={!!errors.email}
                  />
                  {errors.email && <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>}
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Phone Number</Form.Label>
                  <PhoneInput
                    country={"ug"}
                    countryCodeEditable={false}
                    onChange={handlePhoneChange}
                    inputClass="w-100 bg-transparent"
                    inputProps={{ name: "phone_number" }}
                    inputStyle={{
                      fontWeight: 400,
                      lineHeight: 1.5,
                      height: "48px",
                      border: "1px solid #b8b8b878",
                      fontSize: "1rem",
                      padding: "11px 48px 11px 48px",
                    }}
                    isInvalid={!!errors.phone_number}
                  />
                  {errors.phone_number && <Form.Control.Feedback className="d-block" type="invalid">{errors.phone_number}</Form.Control.Feedback>}
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Gender (Optional)</Form.Label>
                  <Select
                    options={genderOptions}
                    placeholder="Select Gender"
                    name="gender"
                    value={genderOptions.find(option => option.value === userData.gender)}
                    onChange={(option) => handleUserInput('gender', option.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Date of Birth (Optional)</Form.Label>
                  <Form.Control
                    type="date"
                    min="1960-01-01"
                    max={getMinimumDate()}
                    value={userData.dob}
                    onChange={(e) => handleUserInput('dob', e.target.value)}
                    isInvalid={!!errors.dob}
                  />
                  {errors.dob && <Form.Control.Feedback type="invalid">{errors.dob}</Form.Control.Feedback>}
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Address</Form.Label>
                  {/* <Form.Control
                    type="text"
                    placeholder="Enter your Address"
                    value={userData.address}
                    name="address"
                    onChange={(e) => handleUserInput('address', e.target.value)}
                    isInvalid={!!errors.address}
                  /> */}
                  <GooglePlacesAutocomplete
                    apiKey={process.env.REACT_APP_MAPS_API}
                    minLengthAutocomplete={3}
                    autocompletionRequest={{
                      componentRestrictions: {
                        country: ['ug']
                      }
                    }}
                    selectProps={{
                      address,
                      onChange: handleAddressChange,
                      placeholder: "Enter driver address",
                      styles: {
                        container: (base, state) => ({
                          ...base,
                          borderRadius: "8px",
                          border: "1px solid #b8b8b878",
                          padding: "2px"
                        }),
                        control: (base, state) => ({
                          ...base,
                          border: "none",
                          backgroundColor: "transparent",
                        })
                      }
                    }}
                  />
                  {errors.address && <Form.Control.Feedback type="invalid" className="d-block">{errors.address}</Form.Control.Feedback>}
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <div className="document-upload-area">
                  <Form.Label>National ID</Form.Label>
                  <h5>Upload National ID</h5>
                  <Form.Control type="file" data-tab="" onChange={(e) => handleFileChange(e, "national_id")} ref={nationalIDRef} accept="image/*" className="d-none" />
                  {
                    previews.national_id ?
                      <img
                        src={previews.national_id}
                        className="document-inner"
                        onClick={() => handleImageClick(nationalIDRef)}
                        alt="Insurance document preview"
                        style={{ cursor: 'pointer', maxWidth: '100%', height: '100px' }}
                      />
                      :
                      <InputFileFieldRender ref={nationalIDRef} />
                  }
                </div>
                {errors.national_id && <Form.Control.Feedback className="d-block" type="invalid">{errors.national_id}</Form.Control.Feedback>}
              </Col>
              <Col md={6} className="mb-3">
                <div className="document-upload-area">
                  <Form.Label>Driving License</Form.Label>
                  <h5>Upload Driving License (Optional)</h5>
                  <Form.Control type="file" data-tab="" onChange={(e) => handleFileChange(e, "driving_permit")} ref={drivingPermitRef} accept="image/*" className="d-none" />
                  {
                    previews.driving_permit ?
                      <img
                        src={previews.driving_permit}
                        className="document-inner"
                        onClick={() => handleImageClick(drivingPermitRef)}
                        alt="Insurance document preview"
                        style={{ cursor: 'pointer', maxWidth: '100%', height: '100px' }}
                      />
                      :
                      <InputFileFieldRender ref={drivingPermitRef} />
                  }
                </div>
                {errors.driving_permit && <Form.Control.Feedback className="d-block" type="invalid">{errors.driving_permit}</Form.Control.Feedback>}
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>National ID Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="National Id Number"
                    value={userData.national_id_number}
                    maxLength={30}
                    onChange={(e) => handleUserInput('national_id_number', e.target.value)}
                    isInvalid={!!errors.national_id_number}
                  />
                  {errors.national_id_number && <Form.Control.Feedback type="invalid">{errors.national_id_number}</Form.Control.Feedback>}
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>License Number (Optional)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="License Number"
                    value={userData.driving_permit_number}
                    maxLength={30}
                    onChange={(e) => handleUserInput('driving_permit_number', e.target.value)}
                    isInvalid={!!errors.driving_permit_number}
                  />
                  {errors.driving_permit_number && <Form.Control.Feedback type="invalid">{errors.driving_permit_number}</Form.Control.Feedback>}
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>National ID Expiry Date (Optional)</Form.Label>
                  <Form.Control
                    type="date"
                    min={new Date().toISOString().split('T')[0]}
                    value={userData.national_id_expiry}
                    onChange={(e) => handleUserInput('national_id_expiry', e.target.value)}
                    isInvalid={!!errors.national_id_expiry}
                  />
                  {errors.national_id_expiry && <Form.Control.Feedback type="invalid">{errors.national_id_expiry}</Form.Control.Feedback>}
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>License Expiry Date (Optional)</Form.Label>
                  <Form.Control
                    type="date"
                    min={new Date().toISOString().split('T')[0]}
                    value={userData.driving_permit_expiry}
                    onChange={(e) => handleUserInput('driving_permit_expiry', e.target.value)}
                    isInvalid={!!errors.driving_permit_expiry}
                  />
                  {errors.driving_permit_expiry && <Form.Control.Feedback type="invalid">{errors.driving_permit_expiry}</Form.Control.Feedback>}
                </Form.Group>
              </Col>
            </Row>
          </div>
          <div className="personal-details">
            <h6>Vehicle Details</h6>
            <div className="profile-detail">
              <img src={previews.vehicle_image ? previews.vehicle_image : vehicleData.vehicle_type === "boda" ? "/images/bike-icon.webp" : "/images/car-icon.webp"} />
              <div className="camera-icon-outer">
                <div className="camera-icon">
                  <img src={require("../assets/images/camera.svg").default} />
                  <Form.Control type="file" data-tab="vehicle" onChange={(e) => handleFileChange(e, "vehicle_image")} accept="image/*" />
                </div>
              </div>
            </div>
            {errors.vehicle_image && <Form.Control.Feedback type="invalid" className="d-block">{errors.vehicle_image}</Form.Control.Feedback>}
            <div className="service-area-content">
              <Tabs
                defaultActiveKey="boda"
                id="uncontrolled-tab-example"
                className="mb-3"
                onSelect={(k) => setVehicleData({ ...vehicleData, "vehicle_type": k })}
              >
                <Tab eventKey="boda" title="Union Boda">
                  <AddVehicle {...addVehicleProps} type="boda" />
                </Tab>
                <Tab eventKey="car" title="Union Car">
                  <AddVehicle {...addVehicleProps} type="car" />
                </Tab>
              </Tabs>
            </div>
          </div>
        </Container>
      </section>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title>Enter 5 - Digit OTP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="otp-varify-card text-center">
            <h3>Phone Verification</h3>
            <p>Enter your OTP code</p>
            <OtpInput
              className="input-value"
              value={otp}
              onChange={setOtp}
              numInputs={4}
              renderSeparator={<span></span>}
              renderInput={(props) => <input {...props} />}
            />
            <p className="did-not-receive-txt">
              Didn’t receive code? <a href="#">Resend again</a>
            </p>
            <Button className="primary-btns w-100 mt-3" onClick={handleShow}>
              Verify
            </Button>
          </div>
          {/* ----------- varify otp succesfully start ----------- */}
          <div className="otp-varify-card text-center">
            <h3>Successfully Verify!!!</h3>
            <p className="my-2">Account Successfully Verified</p>
            <Button className="primary-btns w-100 mt-3" onClick={handleShow}>
              Back to Home
            </Button>
          </div>
          {/* ----------- varify otp succesfully end ----------- */}
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Profile;
